import {gql} from "apollo-angular";
import { baseResponseGraphqlField } from '../../base.graphql';

export const BASE_FREQUENTLY_ASKED_QUESTION_RESPONSE = `
id
uniqueId
questionName
questionAnswer
priority`;

export const GET_FREQUENTLY_ASKED_QUESTION_QUERY = gql`
    query GetAllFaqs {
    getAllFaqs {
      ${baseResponseGraphqlField}
        data {
            ${BASE_FREQUENTLY_ASKED_QUESTION_RESPONSE}
        }
    }
}
`;

export const CREATE_FREQUENTLY_ASKED_QUESTION_MUTATION = gql`
    mutation CreateFaq($input:FAQInputObject!) {
      createFaq(input:$input) {
      ${baseResponseGraphqlField}
        data {
            ${BASE_FREQUENTLY_ASKED_QUESTION_RESPONSE}
        }
    }
}
`;

export const UPDATE_FREQUENTLY_ASKED_QUESTION_MUTATION = gql`
    mutation UpdateFaq($input:FAQInputObject!) {
      updateFaq(input:$input) {
      ${baseResponseGraphqlField}
        data {
            ${BASE_FREQUENTLY_ASKED_QUESTION_RESPONSE}
        }
    }
}
`;

export const DELETE_FREQUENTLY_ASKED_QUESTION_MUTATION = gql`
    mutation DeleteFaq($uniqueId:String!) {
      deleteFaq(uniqueId:$uniqueId) {
      ${baseResponseGraphqlField}
    }
}
`;
